import { get, patch, post } from '@/api/base'

const routesApi = {
  get: async routeUuid => {
    const response = await get({
      path: `routes/${routeUuid}`,
    })
    return response.success ? response.data.route : null
  },
  getDetailed: async routeUuid => {
    const response = await get({
      path: `routes/${routeUuid}`,
      params: { detailed: true },
    })
    return response.success ? response.data.route : null
  },
  getTodays: async params => {
    const response = await get({
      path: 'routes',
      params: { today: true, ...params },
    })
    return response.success ? response.data.routes : []
  },
  getAll: async params => {
    const response = await get({
      path: 'routes',
      params: { ...params },
    })
    return response.success
      ? {
          ...response,
          routes: response.data.routes,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  getGeoJson: async routeUuid => {
    const response = await get({
      path: `routes/${routeUuid}/geojson`,
    })
    return response.success ? response.data : null
  },
  getStops: async routeUuid => {
    const response = await get({
      path: `routes/${routeUuid}/stops`,
      params: { web: true },
    })
    return response.success ? response.data.route_stops : null
  },
  recreate: async (routeUuid, containersList) => {
    return await post({
      path: `routes/${routeUuid}/recreate`,
      params: { containers: containersList },
    })
  },
  update: async (routeUuid, routeName) => {
    return await patch({
      path: `routes/${routeUuid}`,
      params: { name: routeName },
    })
  },
}

export default routesApi
